var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-1 px-2",staticStyle:{"position":"inline-block","align-self":"center","vertical-align":"middle"},style:({
    minWidth: _vm.width,
  })},[_c('span',{staticStyle:{"font-family":"Inter","font-size":"0.875rem","font-weight":"400"}},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }